import { ReactNode } from "react";

/**
 * Единое объяснение «Чат-бот (сценарии)» vs «ИИ-агент».
 * Используется на страницах чат-бота, ИИ-агентов и канала — везде один и тот же текст.
 *
 * Порядок ответа совпадает с логикой бэкенда (decision/decision-engine.ts):
 * менеджер → сценарий чат-бота → ИИ-агент → сообщение ждёт менеджера во «Входящих».
 */

const ROWS: Array<{ label: string; bot: ReactNode; ai: ReactNode }> = [
  { label: "Как отвечает", bot: "Заготовленными сообщениями и кнопками", ai: "Своими словами, на основе знаний о компании" },
  { label: "Когда срабатывает", bot: "На ключевое слово, кнопку, комментарий", ai: "На любой вопрос свободным текстом" },
  {
    label: "Пример",
    bot: "Клиент пишет «цена» под постом → бот присылает прайс в директ",
    ai: "«А у вас есть доставка в Астану?» → агент отвечает и узнаёт телефон",
  },
  { label: "Что настроить", bot: "Сценарий: ключевые слова и ответ", ai: "Описание компании и база знаний" },
  { label: "Расход", bot: "Без ограничений", ai: "Тратит ИИ-ответы по тарифу" },
  { label: "Каналы", bot: "Пока только Instagram", ai: "Instagram, WhatsApp, Telegram" },
];

/** Таблица сравнения. Аналогия: чат-бот — автоответчик с меню, ИИ-агент — консультант. */
export const BotVsAgentTable = () => (
  <div>
    <p className="mb-2">
      <b>Чат-бот</b> — как автоответчик с меню: отвечает по сценарию. <b>ИИ-агент</b> — как консультант,
      который знает вашу компанию: отвечает своими словами. Их можно использовать вместе.
    </p>
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="text-left">
            <th className="py-1 pr-3 w-32"></th>
            <th className="py-1 pr-3">🤖 Чат-бот (сценарии)</th>
            <th className="py-1">🧠 ИИ-агент</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row) => (
            <tr key={row.label} className="border-t align-top">
              <td className="py-1 pr-3 text-gray-500">{row.label}</td>
              <td className="py-1 pr-3">{row.bot}</td>
              <td className="py-1">{row.ai}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

/** Кто отвечает клиенту, если настроено несколько способов. */
export const ReplyOrder = () => (
  <div>
    <div className="font-medium mb-1">Кто отвечает в чате, по порядку:</div>
    <ol className="list-decimal pl-5 flex flex-col gap-1">
      <li><b>Менеджер.</b> Если менеджер ответил в чате, ИИ-агент в этом чате замолкает.</li>
      <li><b>Чат-бот.</b> Если сообщение подошло под сценарий (ключевое слово, кнопка) — разговор идёт по сценарию.</li>
      <li><b>ИИ-агент.</b> Отвечает на всё остальное, если он подключён к каналу.</li>
      <li>Если ни бота, ни агента нет — сообщение ждёт менеджера во «Входящих».</li>
    </ol>
  </div>
);
